import { VisitaTarea } from "./VisitaTarea";
import { Time } from "@angular/common";

export class Visita {


    public idCompania: string;
    public idVisita: string;
    public idPunto: string;
    public nombrePunto: string;
    public direccion: string;
    public longitud: string;
    public latitud: string;
    public telefono: string;
    public email: string;
    public nombreContacto: string;
    public fechaProgramada: Date;
    public ventanaInicio: Date;
    public ventanaFin: Time;
    public numeroGuia: string;
    public transportista: string;
    public estadoVisita: string;

    public tareas: VisitaTarea[];


    public idVehiculo;
    public nombreUsuario;

}